import { useState, useRef } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import BarcodeScanner from './BarcodeScanner';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function BarcodeScannerModal({ onCodeDetected, label = 'カメラ', validation }) {
  const [open, setOpen] = useState(false);
  const [code, setCode] = useState('');
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [historyDisplay, setHistoryDisplay] = useState([]);
  const historyRef = useRef([]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleConfirmModalOpen = () => setIsConfirmModalOpen(true);
  const handleConfirmModalClose = () => setIsConfirmModalOpen(false);

  const handleCodeDetected = (code) => {
    handleConfirmModalOpen();
    setCode(code);
  };

  const handleConfirmCode = () => {
    onCodeDetected(code);
    handleResetCode();
    handleClose();
  };

  const handleResetCode = () => {
    setCode('');
    setHistoryDisplay([]);
    historyRef.current = [];
    handleConfirmModalClose();
  };

  return (
    <div>
      <Button className="bg-blue-btn-primary" onClick={handleOpen}>
        {label}
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <BarcodeScanner
            onCodeDetected={handleCodeDetected}
            code={code}
            setCode={setCode}
            validation={validation}
            historyDisplay={historyDisplay}
            setHistoryDisplay={setHistoryDisplay}
            historyRef={historyRef}
          ></BarcodeScanner>
        </Box>
      </Modal>

      <div>
        <Modal
          open={isConfirmModalOpen}
          onClose={handleResetCode}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="mx-4 md:mx-0"
        >
          <Box sx={style} className={'px-4 py-6 rounded-[16px] w-full md:w-2/6'}>
            <Typography id="modal-modal-title" variant="h6" component="h2" className="text-center">
              検出したコードご確認ください。
            </Typography>
            <Typography id="modal-modal-description" sx={{ my: 4 }} align="center" className="">
              <div className="text-xl">{code}</div>
            </Typography>
            <div className="flex gap-2">
              <button onClick={handleResetCode} type="button" className="flex-1 text-blue-btn-primary">
                やり直し
              </button>
              <button
                onClick={handleConfirmCode}
                type="button"
                className="flex-1 button-size bg-blue-btn-primary mr-4 lg:mr-6"
              >
                OK
              </button>
            </div>
          </Box>
        </Modal>
      </div>
    </div>
  );
}
